
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/chinese-math-class",
      function () {
        return require("private-next-pages/form/chinese-math-class/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/chinese-math-class"])
      });
    }
  